import { ServiceTypeFullNamePipe } from '@aca-new/app/shared/pipes/service-type-full-name/service-type-full-name.pipe';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [ServiceTypeFullNamePipe],
  exports: [ServiceTypeFullNamePipe],
})
export class AppServiceTypeFullNameModule {}
